import { gql } from 'apollo-angular'

import { PERSON_DETAIL_FIELDS } from '../../fragments/person.fragment'

export const GET_EDITOR_BY_ID = gql`
  ${PERSON_DETAIL_FIELDS}
  query GetEditorById($id: Int!) {
    Author(id: $id) {
      ...PersonDetailFields
    }
  }
`
